/* eslint-disable jsx-a11y/alt-text */
import { Image, Text, View } from '@react-pdf/renderer';

import { createPdfStyles } from '../utils/create-pdf-styles';

import { styles as sharedStyles } from './syllabus-styles';

const iconSize = 48;
const checkIcon = '/images/blue-checkmark.png';

const styles = createPdfStyles({
  sectionBox: {
    backgroundColor: 'accent.sky.100',
    borderRadius: 12,
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-start',
    gap: 16,
  },
  iconBox: {
    width: iconSize,
    height: iconSize,
  },
  iconImage: {
    width: iconSize,
    height: iconSize,
  },
  sectionContent: {
    flex: 1,
    flexDirection: 'column',
  },
  heading: {
    fontFamily: 'PolySans',
    fontSize: 16,
    color: 'blue.800',
    lineHeight: 1.3,
    marginBottom: 8,
    fontWeight: 500,
  },
  description: {
    ...sharedStyles.text,
    fontWeight: 500,
    marginBottom: 12,
  },
  list: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    display: 'flex',
    gap: '16px',
  },
  listItem: {
    ...sharedStyles.text,
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkIcon: {
    width: '13.06px',
    height: '16.32px',
    marginRight: 8,
  },
});

function ListItem({ text }: { text: string }) {
  return (
    <View style={styles.listItem}>
      <Image src={checkIcon} style={styles.checkIcon} />
      <Text>{text}</Text>
    </View>
  );
}

export function SyllabusWhyUdacity() {
  return (
    <View style={sharedStyles.section}>
      <Text style={{ ...sharedStyles.sectionTitle, marginBottom: '16px' }}>Why Udacity</Text>
      <View style={sharedStyles.topLevelStack}>
        <View style={styles.sectionBox}>
          <View style={styles.iconBox}>
            <Image src={'/images/icon-checkmark-medal-two.png'} style={styles.iconImage} />
          </View>
          <View style={styles.sectionContent}>
            <Text style={styles.heading}>Demonstrate proficiency with practical projects</Text>
            <Text style={styles.description}>
              Projects are based on real-world scenarios and challenges, allowing you to apply the skills you learn to
              practical situations, while giving you real hands-on experience
            </Text>
            <View style={styles.list}>
              <ListItem text='Gain proven experience' />
              <ListItem text='Retain knowledge longer' />
              <ListItem text='Apply new skills immediately' />
            </View>
          </View>
        </View>
        <View style={styles.sectionBox}>
          <View style={styles.iconBox}>
            <Image src={'/images/icon-hands-shaking-2.png'} style={styles.iconImage} />
          </View>
          <View style={styles.sectionContent}>
            <Text style={styles.heading}>24/7 access to real human support</Text>
            <Text style={styles.description}>
              Reviewers provide timely and constructive feedback on your project submissions, highlighting areas of
              improvement and offering practical tips to enhance your work
            </Text>
            <View style={styles.list}>
              <ListItem text='Get help from subject matter experts' />
              <ListItem text='Gain valuable insights and improve your skills' />
              <ListItem text='Learn industry best practices' />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
